import {useTranslation} from 'react-i18next';
import {RefreshCw} from 'lucide-react';
import {Button} from '@chekinapp/ui';
import {ErrorScene} from 'components/ErrorScene';
import {LanguageModal} from 'components/LanguageModal';

type Props = {
  error: unknown;
};

function ErrorFallback({error: _error}: Props) {
  const {t} = useTranslation();

  return (
    <ErrorScene
      variant="crash"
      title={t('error_crash_title')}
      subtitle={t('error_crash_subtitle')}
      announce={t('error_crash_announce')}
      artClassName="lg:mt-1.5"
    >
      <div className="mt-6 flex w-full max-w-[320px] flex-col gap-2.5">
        <Button variant="primary" onClick={() => window.location.reload()}>
          <RefreshCw size={16} aria-hidden="true" />
          {t('error_crash_reload')}
        </Button>
      </div>

      <LanguageModal />
    </ErrorScene>
  );
}

export {ErrorFallback};
